import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import FormTextFieldPdf from '../../../../common/Forms/FormTextFieldPdf';
import { GridSection } from '../../../Episode.Styled';
import {
  BorderTableCell,
  BorderTableRow,
  GridDivider,
} from '../../../../ui/styled';
import FormCheckboxPdf from '../../../../common/Forms/FormCheckboxPdf';

export const HeaderGrid = ({
  leftTitle1,
  leftTitle2,
  middleHeading,
  rightTitle1,
}) => {
  const renderTitles = (titles) => {
    return titles.map((title, index) => (
      <Typography key={index} variant="h5">
        {title}
      </Typography>
    ));
  };

  return (
    <>
      <Grid item xs={3}>
        {renderTitles([leftTitle1, leftTitle2])}
      </Grid>
      <Grid item xs={6} textAlign="center">
        <Typography variant="h2">{middleHeading}</Typography>
      </Grid>
      <Grid item xs={3} textAlign="end">
        {renderTitles([rightTitle1])}
      </Grid>
    </>
  );
};

export const ReferralFieldGrid = ({ xs, title, defaultValue }) => {
  return (
    <Grid item xs={xs}>
      {Array.isArray(title) ? (
        title.map((item, index) => (
          <>
            <Grid container>
              <Grid item xs={8} key={index}>
                {item.title}
              </Grid>
              <Grid item xs={4} key={index}>
                {item.value}
              </Grid>
            </Grid>
          </>
        ))
      ) : (
        <>
          <Typography>{title}</Typography>
          <FormTextFieldPdf defaultValue={defaultValue} />
        </>
      )}
    </Grid>
  );
};

export const ContactFieldGrid = ({ xs, title }) => {
  return title.map((item, index) => (
    <>
      <Grid item xs={xs}>
        <Typography>{item.title}</Typography>
        <FormTextFieldPdf defaultValue={item.value} />
        <Box my={1} />
      </Grid>
    </>
  ));
};

export const getValidYesNo = (value) => (value ? 'Yes' : 'No');

export const mappedFieldGrid = ({ item }) => {
  return item.map((info, index) => (
    <Grid key={index} item xs={info.xs}>
      <ReferralFieldGrid title={info.title} defaultValue={info.value} />
    </Grid>
  ));
};

export const ParticipantInformation = ({ item }) => {
  return (
    <>
      <Grid mt={1} mx={2} container spacing={1} justifyContent="left">
        {mappedFieldGrid({ item })}
      </Grid>
      <Box my={1} />
      <TransportationDivider xs={12} />
    </>
  );
};

export const GetHeading = ({ heading }) => {
  return (
    <>
      <Grid item xs={12} textAlign="center">
        <Typography variant="h4">{heading}</Typography>
      </Grid>
    </>
  );
};

export const GridSectionData = ({ item, heading }) => {
  return (
    <>
      <GetHeading heading={heading} />
      {mappedFieldGrid({ item })}
    </>
  );
};

export const ContactsGridSection = ({ item, heading }) => {
  return (
    <>
      <GridSection mt={1} mx={2} container spacing={1}>
        <GetHeading heading={heading} />
        {item.map((info, index) => (
          <Grid key={index} item xs={info.xs}>
            <ContactFieldGrid title={info.title} />
          </Grid>
        ))}
      </GridSection>
      <TransportationDivider xs={12} />
    </>
  );
};

export const ScheduleGridSection = ({ item, heading }) => {
  return (
    <>
      <GridSection mt={1} mx={2} container spacing={1}>
        <GridSectionData item={item} heading={heading} />
        <Grid item xs={12} textAlign="right">
          (Flight/Train/Bus Number, STOP Staff, Parole)
        </Grid>
      </GridSection>
      <TransportationDivider xs={12} />
    </>
  );
};

export const MappedPlanCompletedVal = ({ item }) => mappedFieldGrid({ item });

export const TransportationCheckBox = ({ item }) => {
  return (
    <>
      {item.map((item, index) => (
        <Grid item xs={4}>
          <FormCheckboxPdf key={index} item={item} />
        </Grid>
      ))}
    </>
  );
};

export const TransportationDivider = ({ xs }) => {
  return (
    <Grid container mx={2}>
      <Grid item xs={xs}>
        <GridDivider />
      </Grid>
    </Grid>
  );
};

export const TableHeadingData = ({ heading1, heading2 }) => {
  return (
    <BorderTableRow>
      <BorderTableCell colSpan={5} align="center">
        {heading1}
      </BorderTableCell>
      <BorderTableCell colSpan={5} align="center">
        {heading2}
      </BorderTableCell>
    </BorderTableRow>
  );
};

export const CustomTableRow = ({
  label,
  rate,
  quantityEst,
  quantityAct,
  amount,
}) => {
  return (
    <TableRow>
      <TableCell>{label}</TableCell>
      <TableCell>{rate}</TableCell>
      <TableCell>{quantityEst}</TableCell>
      <TableCell>1/4 hours =</TableCell>
      <BorderTableCell>{amount}</BorderTableCell>
      <TableCell>{label}</TableCell>
      <TableCell>{rate}</TableCell>
      <TableCell>{quantityAct}</TableCell>
      <TableCell>1/4 hours =</TableCell>
      <TableCell>{amount}</TableCell>
    </TableRow>
  );
};

export const TableFooterData = ({
  labelEst,
  amountEst,
  labelAct,
  amountAct,
}) => {
  return (
    <BorderTableRow>
      <TableCell colSpan={4}>{labelEst}</TableCell>
      <TableCell>{amountEst}</TableCell>
      <TableCell colSpan={4}>{labelAct}</TableCell>
      <TableCell>{amountAct}</TableCell>
    </BorderTableRow>
  );
};

const searchItem = (searchKey, searchList, returnValueKey = '') => {
  const searchItem = searchList?.find((item) => item.id === searchKey);
  return searchItem[returnValueKey];
};

export const getPropertyById = (id, contacts, property) => {
  if (!contacts || contacts.length === 0) {
    return '';
  }

  const contact = searchItem(id, contacts, property);
  if (contact) {
    return contact[property];
  }

  return '';
};
